import { forwardRef, useEffect, useRef, useState, useImperativeHandle } from 'react'
import Input from './Input'
import Hidden from './Hidden'
import { AutoCompleteTeams } from '../../repo/TeamsRepo'
import AutoCompleteOptions from './AutoCompleteOptions'

var timex

const AutoComplete = forwardRef(function AutoComplete({defaultValue, ...props}, outterRef) {
  const [loading, setLoading] = useState(true);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [lastSelectedObject, setLastSelectedObject] = useState(defaultValue);
  const [showOptions, setShowOptions] = useState(false);
  const autoCompleteRef = useRef();
  const nameRef = useRef();
  const optionsRef = useRef();
  const hiddenInputRef = useRef();

  useImperativeHandle(outterRef, () => {
    return {
      setValue: (newValue) => {
        hiddenInputRef.current.value = newValue;
      },
    };
  }, []);

  useEffect(() => {
    if (defaultValue && defaultValue.name) {
      nameRef.current.value = defaultValue.name
      setLastSelectedObject(defaultValue)
    } else {
      nameRef.current.value = ''
    }
    setLoading(false)
  }, [defaultValue]);

  const autoCompleteOnChangeHandler = (event) => {
    if (!loading) {
      autoCompleteRef.current = event.target.value
      unsetTimerForSearching()
      setTimerForSearching()
    }
  }

  async function searchTeams(q) {
    const resData = await AutoCompleteTeams(q)

    return resData
  }

  const TIMER = 400

  const setTimerForSearching = () => {
    timex = setTimeout(async () => {
      const options = await searchTeams(autoCompleteRef.current)
      setShowOptions(
        options.length > 0
      )
      setAutoCompleteOptions(options)
    }, TIMER)

    return () => {
      unsetTimerForSearching()
    }
  }

  const unsetTimerForSearching = () => {
    try {
      clearTimeout(timex)
    } catch {
    }
  }

  const onSelect = (selectedObject) => {
    setLastSelectedObject(selectedObject)

    nameRef.current.value = selectedObject.name

    try {
      props.onSelectOption(selectedObject)
    } catch {
    }

    setShowOptions(false)
  }

  function handleKeyDown(event) {
    if (event.key === "Escape") {
      handleRestore();
    }

    if (event.key === "Enter" || event.key === "Tab") {
      if (event.target.value === "") {
        handleClear()
      } else {
        handleRestore();
      }

      let form = event.target.form;
      let index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 2].focus();

      event.preventDefault();
    }

    if (event.key === "ArrowDown") {
      if (showOptions) {
        nameRef.current.blur();
        optionsRef.current.children[0].focus();
      }
      event.preventDefault();
    }
  }

  function handleRestore() {
    nameRef.current.value = lastSelectedObject && lastSelectedObject.name ? lastSelectedObject.name : ""
    setShowOptions(false)
  }

  function handleClear() {
    setLastSelectedObject(null)
    setShowOptions(false)
  }

  return <div className='flex flex-col gap-0 relative'>
    <Input
      klass="mb-0"
      ref={nameRef}
      defaultValue={lastSelectedObject && lastSelectedObject.name ? lastSelectedObject.name : ""}
      onChange={autoCompleteOnChangeHandler}
      onKeyDown={handleKeyDown}
      placeholder={props.placeholder || "Type to search..."}
      disabled={props.disabled || false}
      autoComplete="off"
    />

    <AutoCompleteOptions
      show={showOptions}
      options={autoCompleteOptions}
      onSelect={onSelect}
      ref={optionsRef}
    />

    <Hidden
      ref={hiddenInputRef}
      name={props.name}
      id={props.id}
      defaultValue={lastSelectedObject && lastSelectedObject.id ? lastSelectedObject.id : ""}
    />
  </div>;
})

export default AutoComplete
